import React, { Component } from 'react'
import classes from "../../App.module.css"

export class Contact extends Component {
  render() {
    return (
      <div>
       <h1 className={classes.About_title}>Contact page</h1> 
       
      </div>
    )
  }
}

export default Contact
